import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MODE_DELIVERY } from "../../../constants/constants";
import { useConfig } from "../../../context/ConfigContext";
import { RestaurantCart } from "../../../interfaces/Catalogue";
import { DeliveryQuote } from "../../../interfaces/delivery";
import { UserInfo } from "../../../interfaces/user";
import { extractClientAddress } from "../../../utils/deliveryUtils";

interface DeliveryDetailsProps {
  restaurantCart: RestaurantCart;
  deliveryQuote: DeliveryQuote;
  userInfo: UserInfo;
  checkRestaurantDelivery: (
    address: google.maps.places.PlaceResult | undefined
  ) => void;
  onShowChangeAddressModal: () => void;
}

const DeliveryDetails: React.FC<DeliveryDetailsProps> = ({
  restaurantCart,
  deliveryQuote,
  userInfo,
  checkRestaurantDelivery,
  onShowChangeAddressModal,
}) => {
  const { config } = useConfig();
  const dispatch = useDispatch();
  const deliveryAddress = useSelector(
    (state: any) => state.delivery.deliveryAddress
  );

  const clientAddress = extractClientAddress(deliveryAddress || {});
  const [showRestaurantError, setShowRestaurantError] = useState(false);
  const [showModal, setShowModal] = useState(
    restaurantCart.mode != MODE_DELIVERY
  );

  const restaurantId = restaurantCart.restaurant.id;

  return (
    <div>
      <Box pl={1}>
        <Grid container spacing={2}>
          {/* Adresse */}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{ color: "#555555" }}
            >
              Adresse de livraison
            </Typography>

            {/* Left-Right layout */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="flex-start"
              flexWrap="wrap"
              gap={2}
            >
              {/* Left: Address Info */}
              <Box>
                <Typography variant="body2" sx={{ color: "#555555" }}>
                  {clientAddress?.streetAddress}
                  <br />
                  {clientAddress?.zip_code} {clientAddress?.city}
                  {clientAddress?.state ? `, ${clientAddress.state}` : ""}
                </Typography>
                <Typography variant="body2" sx={{ color: "#555555" }}>
                  {clientAddress?.country}
                </Typography>
              </Box>

              {/* Right: Button */}
              <Box ml="auto">
                <Button
                  variant="outlined"
                  size="small"
                  onClick={onShowChangeAddressModal}
                  sx={{
                    color: config?.primaryColor,
                    borderColor: config?.primaryColor,
                    "&:hover": {
                      backgroundColor: config?.primaryColor,
                      color: "#fff",
                      borderColor: config?.primaryColor,
                    },
                  }}
                >
                  Modifier l'adresse
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Infos utilisateur */}
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              sx={{ color: "#555555" }}
            >
              Informations du client
            </Typography>
            <Typography variant="body2" sx={{ color: "#555555" }}>
              {userInfo?.firstName} {userInfo?.lastName}
            </Typography>
            <Typography variant="body2" sx={{ color: "#555555" }}>
              Email : {userInfo?.email}
            </Typography>
            <Typography variant="body2" sx={{ color: "#555555" }}>
              Téléphone : {userInfo?.phoneNumber}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default DeliveryDetails;
